/* eslint-disable react-hooks/exhaustive-deps */
import { FC, useState, useEffect, useRef, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useMutation, ServerError, useLazyQuery } from '@apollo/client'
import { useFormik } from 'formik'
import * as Yup from 'yup'

import { fetchStart, fetchStop } from '../../../../redux/actions/common'
import mutations from '../../../../setup/graphql/mutations'
import query from '../../../../setup/graphql/query'
import Alert from '../../../../_metronic/partials/alert'
import {
  setApplicationComplete,
  setCoApplicant,
  setOpenVerification,
  setSubStep,
} from '../redux/actions'
import { toStr } from '../../loanApplication/steps/Step3'
import PhoneInput from 'react-phone-number-input'
import { RightAeroIcon } from '../../../../svg/RightAeroIcon'
import { Xicon } from '../../../../svg/Xicon'
import { Stack } from 'react-bootstrap'
import { UploadIcon } from '../../../../svg/UploadIcon'
import { LeftArowIcon } from '../../../../svg/LeftArowIcon'
import UserVerification from '../UserVerification'
import { cleanFileNameDynamic } from '../../../constants/commonFunctions'
import {
  uploadCbsReport,
  processCbsReport,
  initiateCbsTransaction,
} from '../../../../components/BankStatementValidator/utils/cbsTransaction'
import { privacyPolicy, toNotice } from '../../../../_metronic/helpers'

const Step1Sub3: FC<any> = ({ getCoApplicant }) => {
  const dispatch = useDispatch()
  const history: any = useHistory()

  localStorage.removeItem('singpass')

  const [showAlert, setShowAlert] = useState<boolean>(false)
  const [alertMsg, setAlertMsg] = useState<string>('')
  const [alertType, setAlertType] = useState<any>('primary')
  // const [information, setInformation] = useState<any>(null);
  const [fileGroup, setFileGroup] = useState<any>([])
  const [saveUserData, onSaveUserData] = useMutation(mutations.CREATE_EXTERNAL_DATA_STORE)
  const [createFileStorage, onSuccessCreateFileStorage] = useMutation(mutations.CREATE_FILE_STORAGE)
  const [deleteFileStorage] = useMutation(mutations.DELETE_FILE_STORAGE)
  const [updateCoApplicant, onUpdateCoApplicant] = useMutation(mutations.UPDATE_SHAREHOLDER_KYC)
  const [fetchBrigs, onSuccessFetchBrigs] = useLazyQuery(query.FETCH_BRIGS_DATA)
  const [queuedCbsFiles, setQueuedCbsFiles] = useState<File[]>([])
  const confirmCheckboxRef = useRef<HTMLDivElement>(null)
  const consentBoxRef = useRef<HTMLDivElement>(null)

  const openVerification = useSelector((state: any) => state.coApplicant.openVerification)

  const stateCompanyVerificationMethod = useSelector(
    (state: any) => state.loan.companyVerificationMethod
  )
  const companyVerificationMethod =
    (localStorage.getItem('UserVerificationMethod')
      ? Number(localStorage.getItem('UserVerificationMethod'))
      : false) || stateCompanyVerificationMethod

  const agentCode = localStorage.getItem('agentCode')
  const applicationType = localStorage.getItem('applicationType')
  const isAgentClientOnboarding = !!(applicationType === 'agent-client-onboarding' || agentCode)

  // const coapplicant = useSelector((state: any) => state.coApplicant.co_applicant);
  const rawPerson = useSelector((state: any) => state.coApplicant.personData)
  const person = useMemo(() => {
    const info =
      rawPerson?.personInfo?.person_info ??
      (rawPerson?.personInfo?.uinfin || rawPerson?.personInfo?.['noa-basic']
        ? rawPerson.personInfo
        : undefined) ??
      rawPerson?.person_info ??
      (rawPerson?.uinfin || rawPerson?.['noa-basic'] ? rawPerson : undefined)
    if (!info) return rawPerson
    const noas = getNoaList(info)
    return {
      ...info,
      ownerprivate:
        info.ownerprivate && typeof info.ownerprivate === 'object'
          ? { ...info.ownerprivate, value: String(info.ownerprivate.value ?? '') }
          : { value: String(info.ownerprivate ?? '') },
      noahistory: { noas },
    }
  }, [rawPerson])

  const hasValue = (value: any) => {
    if (value === undefined || value === null) return false
    const s = String(value).trim().toLowerCase()
    return !['', 'na', 'n/a', 'unavailable', 'undefined', 'null'].includes(s)
  }

  function getNoaList(p: any) {
    if (p?.noahistory?.noas?.length) return p.noahistory.noas
    const noa = p?.['noa-basic'] || p?.['noaBasic'] || p?.['noa']
    if (!noa) return []
    return [
      {
        amount: noa.amount?.value ?? noa.amount,
        yearofassessment: noa.yearofassessment?.value ?? noa.yearofassessment,
      },
    ]
  }

  const coApplicationId = localStorage.getItem('coApplicationId')
  const coApplicant = useSelector((state: any) => state.coApplicant.co_applicant)

  const checkForLeadingTrailingSpaces = (value: string | undefined) => {
    if (!value) return true
    return value === value.trim()
  }

  const backLink = () => {
    dispatch(setSubStep(2))
    dispatch(setOpenVerification(true))
  }
  // CBS initiate transaction on component mount
  useEffect(() => {
    const initiateCbs = async () => {
      try {
        await initiateCbsTransaction()
        console.log('CBS transaction initiated successfully')
      } catch (error) {
        console.error('Failed to initiate CBS transaction:', error)
      }
    }

    initiateCbs()
    if (coApplicant?.kycStatus === 'completed') {
      history.push(`/co-applicant/completed`)
    }
  }, [])

  useEffect(() => {
    if (coApplicant == null) {
      getCoApplicant({
        variables: { shareholderId: localStorage.getItem('coApplicationId') },
      })
    }
  }, [])
  useEffect(() => {
    if (onSaveUserData.called && !onSaveUserData.loading) {
      if (onSaveUserData.data) {
        if (coApplicant.isGuarantor) {
          fetchBrigs({
            variables: {
              coApplicationId: coApplicationId,
            },
          })
        } else {
          updateCoApplicant({
            variables: {
              where: {
                id: coApplicationId,
              },
              data: {
                experianConsent: false,
                kycStatus: 'completed',
              },
            },
          })
        }
      }

      if (onSaveUserData.error) {
        const { networkError } = onSaveUserData.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [onSaveUserData.data, onSaveUserData.error, onSaveUserData.loading])

  useEffect(() => {
    if (onSuccessFetchBrigs.called && !onSuccessFetchBrigs.loading) {
      if (onSuccessFetchBrigs.data) {
        updateCoApplicant({
          variables: {
            where: {
              id: coApplicationId,
            },
            data: {
              experianConsent: true,
              kycStatus: 'completed',
            },
          },
        })
      }

      if (onSuccessFetchBrigs.error) {
        const { networkError } = onSuccessFetchBrigs.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [onSuccessFetchBrigs.data, onSuccessFetchBrigs.error, onSuccessFetchBrigs.loading])

  useEffect(() => {
    if (onUpdateCoApplicant.called && !onUpdateCoApplicant.loading) {
      if (onUpdateCoApplicant.data) {
        dispatch(fetchStop())
        dispatch(setCoApplicant(onUpdateCoApplicant.data.updateShareholderKycStatus))
        dispatch(setApplicationComplete(true))
        history.push(`/co-applicant/completed`)
      }

      if (onUpdateCoApplicant.error) {
        const { networkError } = onUpdateCoApplicant.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
        dispatch(fetchStop())
      }
    }
  }, [onUpdateCoApplicant.data, onUpdateCoApplicant.error, onUpdateCoApplicant.loading])

  const initialValues: any = useMemo(
    () => ({
      uinfin: person?.uinfin?.value ?? '',
      name: person?.name?.value ?? '',
      sex: person?.sex?.desc ?? '',
      // race: person.race.desc,
      nationality: person?.nationality?.desc ?? '',
      dob: person?.dob?.value ?? '',
      email: person?.email?.value ?? '',
      mobileno: person
        ? `${person?.mobileno?.prefix?.value}${person?.mobileno?.areacode?.value}${person?.mobileno?.nbr?.value}`
        : '',
      // regadd: person ? `${person.regadd.block?.value} ${person.regadd.building?.value} ${person.regadd.floor?.value} ${person.regadd.unit?.value} ${person.regadd.street?.value} ${person.regadd.postal?.value}` : '',
      regadd: person ? toStr(person.regadd, 'ADDRESSLOCAL') : '',
      // housingtype: `${person.housingtype.desc} ${person.hdbtype.desc}`,
      // marital: person.marital.desc,
      // edulevel: person.edulevel.desc,
      residentialstatus: person?.residentialstatus?.desc ?? '',
      birthcountry: person?.birthcountry?.desc ?? '',
      occupation: person?.occupation?.value ?? '',
      employment: person?.employment?.value ?? '',
      passportnumber: person?.passportnumber?.value ?? '',
      passportexpirydate: person?.passportexpirydate?.value ?? '',
      passtype: person?.passtype?.desc ?? '',
      passstatus: person?.passstatus?.value ?? '',
      passexpirydate: person?.passexpirydate?.value ?? '',
      hdbtype: person?.hdbtype?.desc ?? '',
      ownerprivate: person?.ownerprivate?.value ?? '',
      noahistory: getNoaList(person),
      confirmCheckbox: false,
      promotionalMarketingCheckbox: false,
    }),
    [person]
  )

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Name is required')
      .matches(/^[a-zA-Z\s*]+$/, 'Name can only contain letters, spaces')
      .test(
        'no-asterisk-only',
        'Name cannot consist of only asterisks or spaces with asterisks',
        (value) => {
          if (!value) return false
          const trimmed = value.trim()
          return !/^[*\s]+$/.test(trimmed)
        }
      )
      .test('no-only-spaces', 'Name cannot be just spaces', (value) =>
        value ? value.trim().length > 0 : false
      )
      .test(
        'no-leading-trailing-spaces',
        'Name cannot have leading or trailing spaces',
        (value) => {
          if (!value) return true
          return value === value.trim()
        }
      ),

    sex: Yup.string()
      .required('Gender is required')
      .matches(/^[a-zA-Z\s]+$/, 'Gender should not contain numbers or special characters')
      .test('no-only-spaces', 'Gender cannot be just spaces', (value) =>
        value ? value.trim().length > 0 : false
      )
      .test(
        'no-leading-trailing-spaces',
        'Gender cannot have leading or trailing spaces',
        (value) => {
          if (!value) return true
          return value === value.trim()
        }
      ),

    nationality: Yup.string()
      .required('Nationality is required')
      .matches(/^[a-zA-Z\s]+$/, 'Nationality should not contain numbers or special characters')
      .test('no-only-spaces', 'Nationality cannot be just spaces', (value) =>
        value ? value.trim().length > 0 : false
      )
      .test(
        'no-leading-trailing-spaces',
        'Nationality cannot have leading or trailing spaces',
        (value) => {
          if (!value) return true
          return value === value.trim()
        }
      ),

    regadd: Yup.string()
      .required('Registered Address is required')
      .min(5, 'Address must be at least 5 characters')
      .max(200, 'Address must be at most 200 characters')
      .test(
        'not-just-spaces',
        'Only spaces are not allowed',
        (value) => !!value && value.trim().length > 0
      )
      .test(
        'contains-alphabets',
        'Address cannot have only numbers or special characters',
        (value) => (value ? /[a-zA-Z]/.test(value) : false)
      )
      .test(
        'no-leading-trailing-spaces',
        'Registered Address cannot have leading or trailing spaces',
        checkForLeadingTrailingSpaces
      ),

    residentialstatus: Yup.string()
      .required('Residential Status is required')
      .matches(
        /^[a-zA-Z\s]+$/,
        'Residential Status should not contain numbers or special characters'
      )
      .test('no-only-spaces', 'Residential Status cannot be just spaces', (value) =>
        value ? value.trim().length > 0 : false
      )
      .test(
        'no-leading-trailing-spaces',
        'Residential Status cannot have leading or trailing spaces',
        (value) => {
          if (!value) return true
          return value === value.trim()
        }
      ),

    dob: Yup.string()
      .required('Date of Birth is required')
      .matches(/^\d{4}-\d{2}-\d{2}$/, 'Date format must be YYYY-MM-DD')
      .test('is-valid-date', 'Please enter a valid date', (value: any) => {
        if (!value) return true
        // Parse the date and check if it's valid
        const date = new Date(value)
        if (isNaN(date.getTime())) return false

        // Verify that the parts match what was actually set
        // This catches cases like 2021-02-31 which would be converted to 2021-03-03 silently
        const [year, month, day] = value.split('-').map(Number)
        const parsedDate = new Date(date)
        return (
          parsedDate.getFullYear() === year &&
          parsedDate.getMonth() + 1 === month &&
          parsedDate.getDate() === day
        )
      })
      .test('not-future', 'Date of Birth cannot be in the future', (value: any) => {
        if (!value) return true
        const date = new Date(value)
        return !isNaN(date.getTime()) && date <= new Date()
      }),

    uinfin: Yup.string()
      .required('NRIC/FIN is required')
      .matches(/^[a-zA-Z0-9]+$/, 'NRIC/FIN should only contain letters and numbers')
      .test('alphanumeric', 'NRIC/FIN must contain both letters and numbers', (value) => {
        if (!value) return false
        return /[a-zA-Z]/.test(value) && /\d/.test(value)
      })
      .test(
        'no-leading-trailing-spaces',
        'NRIC/FIN cannot have leading or trailing spaces',
        (value) => {
          if (!value) return true
          return value === value.trim()
        }
      ),
    mobileno: Yup.string()
      .required('Mobile Number is required')
      .matches(/^\+?\d{8,15}$/, 'Please enter a valid mobile number with country code')
      .test('min-length', 'Mobile number must be at least 8 digits', (value) =>
        value ? value.replace(/\D/g, '').length >= 8 : false
      )
      .test(
        'no-leading-trailing-spaces',
        'Mobile number cannot have leading or trailing spaces',
        (value) => {
          if (!value) return true
          return value === value.trim()
        }
      )
      .trim(),

    email: Yup.string()
      .required('Email is required')
      .test(
        'no-leading-trailing-spaces',
        'Email cannot have leading or trailing spaces',
        (value) => {
          if (!value) return true
          return value === value.trim()
        }
      )
      .email('Please enter a valid email address')
      .matches(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        'Please enter a valid email address'
      )
      .test('no-only-spaces', 'Email cannot be just spaces', (value) =>
        value ? value.trim().length > 0 : false
      ),
    ownerprivate: Yup.string(),
    confirmCheckbox: Yup.bool().oneOf([true], 'Please consent to above mandatory terms'),
  })

  const removeSingleFile = async (id: string) => {
    // find the file's name before removing (so we can drop from the queue)
    const toRemove = fileGroup.find((o: any) => o.id === id)
    const removedName = toRemove?.file?.filename

    const _fileGroup = fileGroup.filter((o: any) => o.id !== id)
    setFileGroup(_fileGroup)

    // if it was a queued CBS file, remove it from queue by name
    if (toRemove?.type === 'credit-bureau-singapore-document' && removedName) {
      setQueuedCbsFiles((prev) =>
        prev.filter((f) => cleanFileNameDynamic(f.name) !== cleanFileNameDynamic(removedName))
      )
    }

    await deleteFileStorage({ variables: { where: { id } } })
  }

  const isValidFile = (event: any, fileTypes: string[], docType: string = '') => {
    const excelTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
      'application/vnd.ms-excel', // .xls
      'application/octet-stream', // Some Excel files might have this type
      'application/zip', // .xlsx is actually a zip file
    ]

    const isExcelFile = (file: File) => {
      const fileName = file.name.toLowerCase()
      return (
        excelTypes.includes(file.type) ||
        fileName.endsWith('.xlsx') ||
        fileName.endsWith('.xls') ||
        file.type === ''
      ) // Sometimes Excel files might not have a type
    }

    const isPdfFile = (file: File) => {
      return file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf')
    }

    const isValidType = (file: File) => {
      if (fileTypes.includes('application/pdf') && isPdfFile(file)) return true
      if (
        (fileTypes.includes('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') ||
          fileTypes.includes('application/vnd.ms-excel')) &&
        isExcelFile(file)
      )
        return true
      return fileTypes.includes(file.type)
    }

    const checkType = [...event.target.files].some((file: File) => !isValidType(file))

    if (checkType) {
      const docTypeDisplay = getDocTypeDisplay(docType)

      setShowAlert(true)
      setAlertMsg(`Please upload a valid ${docTypeDisplay}`)
      setAlertType('primary')
      // Clear the file input
      event.target.value = ''
      event.target.files = null
      return false
    }
    return true
  }

  const getDocTypeDisplay = (docType: string): string => {
    switch (docType) {
      case 'identity-proof':
        return 'Identity Proof'
      case 'credit-bureau-singapore-document':
        return 'Credit Bureau Singapore Document'
      case 'mlcb-report':
        return 'MLCB Report'
      case 'noa-document':
        return 'NOA Document'
      default:
        return 'File'
    }
  }

  const handleFileUpload = async (
    event: any,
    type: string,
    fileType: string[] = ['application/pdf']
  ) => {
    if (event.target.validity.valid) {
      let files = []
      let uploadDocs = []

      const isValid = isValidFile(event, fileType, type)

      if (!isValid) return

      for (let file of event.target.files) {
        const isExists = fileGroup.some(
          (f: any) =>
            cleanFileNameDynamic(f.file.filename) === cleanFileNameDynamic(file.name) &&
            f.type === type
        )

        if (!isExists) {
          file.filename = file.name
          files.push({ type: type, file })
          uploadDocs.push({
            shareholderKycStatus: {
              connect: {
                id: coApplicationId,
              },
            },
            fileType: type,
            documentFile: {
              upload: file,
            },
            updatedByUserName: coApplicant?.personName ?? formik?.values?.name,
          })

          if (type === 'credit-bureau-singapore-document') {
            const alreadyUploaded = fileGroup.some(
              (f: any) => f.type === 'credit-bureau-singapore-document'
            )
            if (alreadyUploaded) {
              setShowAlert(true)
              setAlertMsg('Only one CBS document can be uploaded.')
              setAlertType('primary')
              event.target.value = ''
              return
            }

            setQueuedCbsFiles((prev) => {
              const exists = prev.some(
                (f) => cleanFileNameDynamic(f.name) === cleanFileNameDynamic(file.name)
              )
              return exists ? prev : [...prev, file]
            })
          }
        } else {
          event.target.value = ''
          setShowAlert(true)
          setAlertMsg('File already exists')
          setAlertType('primary')
          return
        }
      }

      if (files.length) {
        event.target.value = ''
        createFileStorage({
          variables: {
            data: uploadDocs,
          },
        })
        event.target.value = ''
        dispatch(fetchStart())
      }
    }
  }

  useEffect(() => {
    if (onSuccessCreateFileStorage.called && !onSuccessCreateFileStorage.loading) {
      dispatch(fetchStop())
      if (onSuccessCreateFileStorage.data) {
        if (onSuccessCreateFileStorage.data) {
          const { createFileStorages } = onSuccessCreateFileStorage.data
          let file = [...fileGroup]
          for (const document of createFileStorages) {
            const _file = {
              id: document.id,
              type: document.fileType,
              file: document.documentFile,
            }
            file.push(_file)
          }

          setFileGroup(file)

          onSuccessCreateFileStorage.reset()
        }
      } else {
      }

      if (onSuccessCreateFileStorage.error) {
        const { networkError } = onSuccessCreateFileStorage.error
        let errorList = 'ERROR: '
        if (networkError && (networkError as ServerError)) {
          errorList =
            errorList +
            (networkError as ServerError as any).result.errors
              .map((error: any) => error.message)
              .join(', ')
        }
        setShowAlert(true)
        setAlertMsg(errorList)
        setAlertType('primary')
      }
    }
  }, [
    onSuccessCreateFileStorage.loading,
    onSuccessCreateFileStorage.data,
    onSuccessCreateFileStorage.error,
    onSuccessCreateFileStorage.called,
  ])

  function fileGroupValidation() {
    if (companyVerificationMethod === 2 && !isAgentClientOnboarding) {
      return (
        fileGroup.some((f: any) => f.type === 'mlcb-report') &&
        fileGroup.some((f: any) => f.type === 'credit-bureau-singapore-document')
      )
    } else if (companyVerificationMethod === 1 && !isAgentClientOnboarding) {
      return (
        fileGroup.some((f: any) => f.type === 'mlcb-report') &&
        fileGroup.some((f: any) => f.type === 'credit-bureau-singapore-document')
      )
    }
    return true
  }
  // Formik
  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values, { setStatus, setSubmitting }) => {
      if (coApplicationId && fileGroupValidation()) {
        // START loader before CBS ops
        dispatch(fetchStart())

        try {
          // 1) If we have queued CBS files, upload *all* of them now
          if (queuedCbsFiles.length) {
            const loanApplicationId = localStorage.getItem('loanApplicationId')!
            const shareholderId = localStorage.getItem('coApplicationId')!
            const currentCalendarYear = new Date().getFullYear()
            const financialYear = (currentCalendarYear - 1).toString()

            // Upload in parallel (or sequentially if you prefer)
            await Promise.all(
              queuedCbsFiles.map((file) =>
                uploadCbsReport(file, loanApplicationId, financialYear, shareholderId)
              )
            )
          }

          // 2) Then process CBS (only once)
          await processCbsReport()

          // 3) Proceed with your existing save flow
          const trimmedValues = Object.fromEntries(
            Object.entries(values).map(([k, v]) => [k, typeof v === 'string' ? v.trim() : v])
          )

          await saveUserData({
            variables: {
              data: {
                shareholderKycStatus: { connect: { id: coApplicationId } },
                type: 'singpass',
                data: trimmedValues,
              },
            },
          })

          // Clear queue after successful submit
          setQueuedCbsFiles([])
        } catch (err) {
          // Surface error but do not block stop; you can choose to hard-block if needed
          console.error('CBS upload/process or saveUserData failed:', err)
          setShowAlert(true)
          setAlertMsg('Something went wrong while submitting. Please try again.')
          setAlertType('primary')
        } finally {
          // If saveUserData effect also calls fetchStop(), calling it twice is safe (idempotent in most setups)
          dispatch(fetchStop())
          setSubmitting(false)
        }
      }
    },
  })

  useEffect(() => {
    if (formik.submitCount > 0 && formik.errors.confirmCheckbox && confirmCheckboxRef.current) {
      confirmCheckboxRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }
  }, [formik.submitCount, formik.errors.confirmCheckbox])

  return (
    <div className='d-flex flex-column flex-column-fluid w-100'>
      <div className='notice d-flex banner text-start p-6 mb-5'>
        <div className='d-flex flex-stack flex-grow-1'>
          <div>
            <h2>User Profile</h2>
            <div className='fs-3'>
              {companyVerificationMethod === 2
                ? 'Fill out details Manually'
                : 'The following details have been provided to us by MyInfo Singpass'}
            </div>
          </div>
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className='cardNew'>
          <div className='section-heading'></div>
          <h2>Personal Information</h2>
          <hr className='text-gray-400' />
          <div className='row'>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                NRIC/FIN
              </label>
              <div className='col-sm-12'>
                <input
                  name='uinfin'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.uinfin}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.uinfin && formik.errors.uinfin && (
                  <div className='text-danger mt-2'>{formik.errors.uinfin}</div>
                )}
              </div>
            </div>

            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Name
              </label>
              <div className='col-sm-12'>
                <input
                  name='name'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.name}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.name && formik.errors.name && (
                  <div className='text-danger mt-2'>{formik.errors.name}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Sex
              </label>
              <div className='col-sm-12'>
                <input
                  name='sex'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.sex}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.sex && formik.errors.sex && (
                  <div className='text-danger mt-2'>{formik.errors.sex}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Date of Birth
              </label>
              <div className='col-sm-12'>
                <input
                  name='dob'
                  type='text'
                  placeholder='YYYY-MM-DD'
                  className='form-control form-control-solid'
                  value={formik.values.dob}
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    const input = e.target.value
                    // Remove any non-digit characters
                    const digitsOnly = input.replace(/\D/g, '')

                    // Format with hyphens as user types
                    let formattedDate = ''
                    if (digitsOnly.length > 0) {
                      // Add year part (up to 4 digits)
                      formattedDate += digitsOnly.substring(0, Math.min(4, digitsOnly.length))

                      // Add month part with hyphen
                      if (digitsOnly.length > 4) {
                        formattedDate +=
                          '-' + digitsOnly.substring(4, Math.min(6, digitsOnly.length))
                      }

                      // Add day part with hyphen
                      if (digitsOnly.length > 6) {
                        formattedDate +=
                          '-' + digitsOnly.substring(6, Math.min(8, digitsOnly.length))
                      }
                    }

                    // Update formik value with formatted date
                    formik.setFieldValue('dob', formattedDate)
                  }}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.dob && formik.errors.dob && (
                  <div className='text-danger mt-2'>{formik.errors.dob}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Mobile Number
              </label>
              <div className='col-sm-12'>
                <PhoneInput
                  id='mobileno'
                  international
                  defaultCountry='SG'
                  value={formik.values.mobileno}
                  onBlur={formik.handleBlur}
                  onChange={(value) => formik.setFieldValue('mobileno', value)}
                  className='int-phone-input rounded-top rounded-bottom'
                />
                {formik.touched.mobileno && formik.errors.mobileno && (
                  <div className='text-danger mt-2'>{formik.errors.mobileno}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Email
              </label>
              <div className='col-sm-12'>
                <input
                  name='email'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.email}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  // disabled={companyVerificationMethod === 1}
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='text-danger mt-2'>{formik.errors.email}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Nationality
              </label>
              <div className='col-sm-12'>
                <input
                  name='nationality'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.nationality}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.nationality && formik.errors.nationality && (
                  <div className='text-danger mt-2'>{formik.errors.nationality}</div>
                )}
              </div>
            </div>
            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Residential Status
              </label>
              <div className='col-sm-12'>
                <input
                  name='residentialstatus'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.residentialstatus}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.residentialstatus && formik.errors.residentialstatus && (
                  <div className='text-danger mt-2'>{formik.errors.residentialstatus}</div>
                )}
              </div>
            </div>

            <div className='col-md-6 mb-5'>
              <label htmlFor='' className='input-field-label required'>
                Registered Address
              </label>
              <div className='col-sm-12'>
                <input
                  name='regadd'
                  type='text'
                  className='form-control form-control-solid'
                  value={formik.values.regadd}
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  disabled={companyVerificationMethod === 1}
                />
                {formik.touched.regadd && formik.errors.regadd && (
                  <div className='text-danger mt-2'>{formik.errors.regadd}</div>
                )}
              </div>
            </div>
            {/* files upload */}
            {companyVerificationMethod === 2 && (
              <div className='row'>
                <div className='col-md-6 mb-5'>
                  <div className='mb-2'>
                    <label
                      htmlFor=''
                      style={{ fontSize: '16px', fontWeight: 500 }}
                      className='input-field-label required mb-0'
                    >
                      Identity Proof (Optional)
                    </label>
                  </div>
                  <span
                    className='text-primary fw-bold mb-7'
                    style={{
                      fontSize: '14px',
                      display: 'inline-block',
                      lineHeight: '1.1',
                    }}
                  >
                    Upload Photo Identity Proof (NRIC, Passport, etc.)
                  </span>
                  <div
                    className='uploadBoxCoApp'
                    style={{
                      border: '1px dashed var(--primary-color)',
                      background: 'var(--primary-light-color)',
                      minHeight: '150px',
                      fontSize: '14px',
                      marginBottom: '15px',
                      borderRadius: '10px',
                      alignItems: 'center',
                    }}
                    onDrop={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                      const files = e.dataTransfer.files
                      if (files.length) {
                        const event = { target: { files, validity: { valid: true } } }
                        handleFileUpload(event, 'identity-proof', [
                          'image/jpeg',
                          'image/png',
                          'image/jpg',
                          'application/pdf',
                        ])
                      }
                    }}
                    onDragOver={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                    onDragLeave={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                  >
                    <Stack
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      gap={2} // Increased gap for better spacing
                    >
                      <div className='upload mb-4'>
                        <input
                          id='upload-identity-proof'
                          type='file'
                          multiple
                          accept='image/jpeg, image/png, image/jpg, application/pdf'
                          onChange={(e: any) =>
                            handleFileUpload(e, 'identity-proof', [
                              'image/jpeg',
                              'image/png',
                              'image/jpg',
                              'application/pdf',
                            ])
                          }
                          onDrop={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                            const files = e.dataTransfer.files
                            if (files.length) {
                              const event = { target: { files, validity: { valid: true } } }
                              handleFileUpload(event, 'identity-proof', [
                                'image/jpeg',
                                'image/png',
                                'image/jpg',
                                'application/pdf',
                              ])
                            }
                          }}
                          onDragOver={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                          onDragLeave={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                        ></input>
                        <label
                          htmlFor='upload-identity-proof'
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            className='file-uploader'
                            style={{
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                            }}
                          >
                            <UploadIcon color='var(--primary-color)' />

                            <span className='dragDropTitle'>
                              Drag & Drop Identity Proof Documents
                            </span>
                          </div>
                          <div className='file-uploader-sub'>Supported formats: JPEG, PNG, PDF</div>
                        </label>
                      </div>
                    </Stack>
                  </div>
                  <div className='uploadedCapsulesWrap'>
                    <Stack
                      className='uploadedCapsules gridCapsules'
                      style={{
                        display: 'grid', // Change to grid layout
                        gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                        gap: '12px', // Adjusted gap for better spacing
                        fontSize: '12px',
                        minWidth: '100%',
                      }}
                    >
                      {fileGroup && fileGroup.length > 0 && (
                        <>
                          {fileGroup
                            .filter(({ type }: any) => type === 'identity-proof')
                            .map(({ file, type, id }: any, i: number) => {
                              const filename = file.filename.split('.')
                              const name = filename[0].substring(0, 10)
                              const extension = filename[1]

                              return (
                                <div
                                  key={i}
                                  style={{
                                    fontSize: 14,
                                    color: '#616B75',
                                    background: '#F9FAFA',
                                    borderRadius: '20px',
                                    border: '1px solid #E0E0E0',
                                    padding: '8px 16px',
                                    display: 'flex', // Use flex to position items
                                    justifyContent: 'space-between', // Space between text and icon
                                    alignItems: 'center', // Center items vertically
                                    width: '100%', // Set to 100% to fill the grid cell
                                  }}
                                  title={file.filename}
                                >
                                  <span>{`${name}...${extension}`}</span>
                                  <Xicon
                                    onClick={() => removeSingleFile(id)}
                                    className='cursor-pointer'
                                  />
                                </div>
                              )
                            })}
                        </>
                      )}
                    </Stack>
                  </div>
                </div>
                {!isAgentClientOnboarding && (
                  <>
                    <div className='col-md-6 mb-5'>
                      <div className='mb-2'>
                        <label
                          htmlFor=''
                          style={{ fontSize: '16px', fontWeight: 500 }}
                          className='input-field-label required mb-0'
                        >
                          CBS Documents
                        </label>
                      </div>
                      <a
                        className='text-primary fw-bold mb-7'
                        style={{
                          fontSize: '14px',
                          borderBottom: '1px solid var(--primary-color)',
                          cursor: 'pointer',
                          display: 'inline-block',
                          lineHeight: '1.1',
                        }}
                        href='https://www.creditbureau.com.sg/buy-my-credit-report.html'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Learn How To Download?
                      </a>
                      <div
                        className='uploadBoxCoApp'
                        style={{
                          border: '1px dashed var(--primary-color)',
                          background: 'var(--primary-light-color)',
                          minHeight: '150px',
                          fontSize: '14px',
                          marginBottom: '15px',
                          borderRadius: '10px',
                          alignItems: 'center',
                        }}
                        onDrop={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                          const files = e.dataTransfer.files
                          if (files.length) {
                            const event = { target: { files, validity: { valid: true } } }
                            handleFileUpload(event, 'credit-bureau-singapore-document', [
                              'application/pdf',
                              'application/msword',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                            ])
                          }
                        }}
                        onDragOver={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                        onDragLeave={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                      >
                        <Stack
                          style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                          gap={2} // Increased gap for better spacing
                        >
                          <div className='upload mb-4'>
                            <input
                              id='upload-credit-bureau-singapore-document'
                              type='file'
                              // multiple we dont take multiple files now.
                              accept='.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                              onChange={(e: any) =>
                                handleFileUpload(e, 'credit-bureau-singapore-document', [
                                  'application/pdf',
                                  'application/msword',
                                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                ])
                              }
                              onDrop={(e: React.DragEvent) => {
                                e.preventDefault()
                                e.stopPropagation()
                                const files = e.dataTransfer.files
                                if (files.length) {
                                  const event = { target: { files, validity: { valid: true } } }
                                  handleFileUpload(event, 'credit-bureau-singapore-document', [
                                    'application/pdf',
                                    'application/msword',
                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                  ])
                                }
                              }}
                              onDragOver={(e: React.DragEvent) => {
                                e.preventDefault()
                                e.stopPropagation()
                              }}
                              onDragLeave={(e: React.DragEvent) => {
                                e.preventDefault()
                                e.stopPropagation()
                              }}
                            ></input>
                            <label
                              htmlFor='upload-credit-bureau-singapore-document'
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <div
                                className='file-uploader'
                                style={{
                                  cursor: 'pointer',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                <UploadIcon color='var(--primary-color)' />

                                <span className='dragDropTitle'>Drag & Drop CBS Documents</span>
                              </div>
                              <div className='file-uploader-sub'>Supported formats: PDF, DOCX</div>
                            </label>
                          </div>
                        </Stack>
                      </div>
                      <div className='uploadedCapsulesWrap'>
                        <Stack
                          className='uploadedCapsules gridCapsules'
                          style={{
                            display: 'grid', // Change to grid layout
                            gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                            gap: '12px', // Adjusted gap for better spacing
                            fontSize: '12px',
                            minWidth: '100%',
                          }}
                        >
                          {fileGroup && fileGroup.length > 0 && (
                            <>
                              {fileGroup
                                .filter(
                                  ({ type }: any) => type === 'credit-bureau-singapore-document'
                                )
                                .map(({ file, type, id }: any, i: number) => {
                                  const filename = file.filename.split('.')
                                  const name = filename[0].substring(0, 10)
                                  const extension = filename[1]

                                  return (
                                    <>
                                      <div
                                        key={i}
                                        style={{
                                          fontSize: 14,
                                          color: '#616B75',
                                          background: '#F9FAFA',
                                          borderRadius: '20px',
                                          border: '1px solid #E0E0E0',
                                          padding: '8px 16px',
                                          display: 'flex', // Use flex to position items
                                          justifyContent: 'space-between', // Space between text and icon
                                          alignItems: 'center', // Center items vertically
                                          width: '100%', // Set to 100% to fill the grid cell
                                        }}
                                        title={file.filename}
                                      >
                                        <span>{`${name}...${extension}`}</span>
                                        <Xicon
                                          onClick={() => removeSingleFile(id)}
                                          className='cursor-pointer'
                                        />
                                      </div>
                                    </>
                                  )
                                })}
                            </>
                          )}
                        </Stack>
                      </div>
                    </div>
                    <div className='col-md-6 mb-5'>
                      <div className='mb-2'>
                        <label
                          htmlFor=''
                          style={{ fontSize: '16px', fontWeight: 500 }}
                          className='input-field-label required mb-0'
                        >
                          MLCB Report
                        </label>
                      </div>
                      <a
                        className='text-primary fw-bold mb-7'
                        style={{
                          fontSize: '14px',
                          borderBottom: '1px solid var(--primary-color)',
                          cursor: 'pointer',
                          display: 'inline-block',
                          lineHeight: '1.1',
                        }}
                        href='https://www.mlcb.com.sg/buy-loan.html'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Learn How To Download?
                      </a>
                      <div
                        className='uploadBoxCoApp'
                        style={{
                          border: '1px dashed var(--primary-color)',
                          background: 'var(--primary-light-color)',
                          minHeight: '150px',
                          fontSize: '14px',
                          marginBottom: '15px',
                          borderRadius: '10px',
                          alignItems: 'center',
                        }}
                        onDrop={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                          const files = e.dataTransfer.files
                          if (files.length) {
                            const event = { target: { files, validity: { valid: true } } }
                            handleFileUpload(event, 'mlcb-report', [
                              'application/pdf',
                              'application/msword',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                            ])
                          }
                        }}
                        onDragOver={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                        onDragLeave={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                      >
                        <Stack
                          style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                          gap={2} // Increased gap for better spacing
                        >
                          <div className='upload mb-4'>
                            <input
                              id='upload-mlcb-report'
                              type='file'
                              multiple
                              accept='.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                              onChange={(e: any) =>
                                handleFileUpload(e, 'mlcb-report', [
                                  'application/pdf',
                                  'application/msword',
                                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                ])
                              }
                              onDrop={(e: React.DragEvent) => {
                                e.preventDefault()
                                e.stopPropagation()
                                const files = e.dataTransfer.files
                                if (files.length) {
                                  const event = { target: { files, validity: { valid: true } } }
                                  handleFileUpload(event, 'mlcb-report', [
                                    'application/pdf',
                                    'application/msword',
                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                  ])
                                }
                              }}
                              onDragOver={(e: React.DragEvent) => {
                                e.preventDefault()
                                e.stopPropagation()
                              }}
                              onDragLeave={(e: React.DragEvent) => {
                                e.preventDefault()
                                e.stopPropagation()
                              }}
                            ></input>
                            <label
                              htmlFor='upload-mlcb-report'
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <div
                                className='file-uploader'
                                style={{
                                  cursor: 'pointer',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                <UploadIcon color='var(--primary-color)' />

                                <span className='dragDropTitle'>Drag & Drop MLCB Report</span>
                              </div>
                              <div className='file-uploader-sub'>Supported formats: PDF, DOCX</div>
                            </label>
                          </div>
                        </Stack>
                      </div>
                      <div className='uploadedCapsulesWrap'>
                        <Stack
                          className='uploadedCapsules gridCapsules'
                          style={{
                            display: 'grid', // Change to grid layout
                            gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                            gap: '12px', // Adjusted gap for better spacing
                            fontSize: '12px',
                            minWidth: '100%',
                          }}
                        >
                          {fileGroup && fileGroup.length > 0 && (
                            <>
                              {fileGroup
                                .filter(({ type }: any) => type === 'mlcb-report')
                                .map(({ file, type, id }: any, i: number) => {
                                  const filename = file.filename.split('.')
                                  const name = filename[0].substring(0, 10)
                                  const extension = filename[1]

                                  return (
                                    <>
                                      <div
                                        key={i}
                                        style={{
                                          fontSize: 14,
                                          color: '#616B75',
                                          background: '#F9FAFA',
                                          borderRadius: '20px',
                                          border: '1px solid #E0E0E0',
                                          padding: '8px 16px',
                                          display: 'flex', // Use flex to position items
                                          justifyContent: 'space-between', // Space between text and icon
                                          alignItems: 'center', // Center items vertically
                                          width: '100%', // Set to 100% to fill the grid cell
                                        }}
                                        title={file.filename}
                                      >
                                        <span>{`${name}...${extension}`}</span>
                                        <Xicon
                                          onClick={() => removeSingleFile(id)}
                                          className='cursor-pointer'
                                        />
                                      </div>
                                    </>
                                  )
                                })}
                            </>
                          )}
                        </Stack>
                      </div>
                    </div>
                    <div className='col-md-6 mb-5'>
                      <div className='mb-2'>
                        <label
                          htmlFor=''
                          style={{ fontSize: '16px', fontWeight: 500 }}
                          className='input-field-label required mb-0'
                        >
                          Notice of Assessment (NOA) (Optional)
                        </label>
                      </div>
                      <a
                        className='text-primary fw-bold mb-7'
                        style={{
                          fontSize: '14px',
                          borderBottom: '1px solid var(--primary-color)',
                          cursor: 'pointer',
                          display: 'inline-block',
                          lineHeight: '1.1',
                        }}
                        href='https://www.iras.gov.sg/taxes/individual-income-tax/basics-of-individual-income-tax/receive-tax-bill-pay-tax-check-refunds/getting-my-tax-assessment'
                        target='_blank'
                        rel='noopener noreferrer'
                      >
                        Learn How To Download?
                      </a>
                      <div
                        className='uploadBoxCoApp'
                        style={{
                          border: '1px dashed var(--primary-color)',
                          background: 'var(--primary-light-color)',
                          minHeight: '150px',
                          fontSize: '14px',
                          marginBottom: '18px',
                          borderRadius: '10px',
                          alignItems: 'center',
                        }}
                        onDrop={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                          const files = e.dataTransfer.files
                          if (files.length) {
                            const event = { target: { files, validity: { valid: true } } }
                            handleFileUpload(event, 'noa-document', [
                              'application/pdf',
                              'application/msword',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                              'application/vnd.ms-excel',
                              'application/octet-stream',
                            ])
                          }
                        }}
                        onDragOver={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                        onDragLeave={(e: React.DragEvent) => {
                          e.preventDefault()
                          e.stopPropagation()
                        }}
                      >
                        <Stack
                          style={{
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                          gap={2} // Increased gap for better spacing
                        >
                          <div className='upload mb-4'>
                            <input
                              id='upload-noa'
                              type='file'
                              multiple
                              accept='.pdf,.doc,.docx,application/msword,.xlsx,.xls,application/pdf,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel,application/octet-stream'
                              onChange={(e: any) =>
                                handleFileUpload(e, 'noa-document', [
                                  'application/pdf',
                                  'application/msword',
                                  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                  'application/vnd.ms-excel',
                                  'application/octet-stream',
                                ])
                              }
                              onDrop={(e: React.DragEvent) => {
                                e.preventDefault()
                                e.stopPropagation()
                                const files = e.dataTransfer.files
                                if (files.length) {
                                  const event = { target: { files, validity: { valid: true } } }
                                  handleFileUpload(event, 'noa-document', [
                                    'application/pdf',
                                    'application/msword',
                                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                                    'application/vnd.ms-excel',
                                    'application/octet-stream',
                                  ])
                                }
                              }}
                              onDragOver={(e: React.DragEvent) => {
                                e.preventDefault()
                                e.stopPropagation()
                              }}
                              onDragLeave={(e: React.DragEvent) => {
                                e.preventDefault()
                                e.stopPropagation()
                              }}
                            ></input>
                            <label
                              htmlFor='upload-noa'
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                              }}
                            >
                              <div
                                className='file-uploader'
                                style={{
                                  cursor: 'pointer',
                                  display: 'flex',
                                  flexDirection: 'column',
                                  alignItems: 'center',
                                }}
                              >
                                <UploadIcon color='var(--primary-color)' />

                                <span className='dragDropTitle'>
                                  Drag & Drop Latest 2 Year(s) NOA
                                </span>
                              </div>
                              <div className='file-uploader-sub'>
                                Supported formats: PDF, DOCX, XLSX, XLS
                              </div>
                            </label>
                          </div>
                        </Stack>
                      </div>
                      <div className='uploadedCapsulesWrap'>
                        <Stack
                          className='uploadedCapsules gridCapsules'
                          style={{
                            display: 'grid', // Change to grid layout
                            gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                            gap: '12px', // Adjusted gap for better spacing
                            fontSize: '12px',
                            minWidth: '100%',
                          }}
                        >
                          {fileGroup && fileGroup.length > 0 && (
                            <>
                              {fileGroup
                                .filter(({ type }: any) => type === 'noa-document')
                                .map(({ file, type, id }: any, i: number) => {
                                  const filename = file.filename.split('.')
                                  const name = filename[0].substring(0, 10)
                                  const extension = filename[1]

                                  return (
                                    <div
                                      key={i}
                                      style={{
                                        fontSize: 14,
                                        color: '#616B75',
                                        background: '#F9FAFA',
                                        borderRadius: '20px',
                                        border: '1px solid #E0E0E0',
                                        padding: '8px 16px',
                                        display: 'flex', // Use flex to position items
                                        justifyContent: 'space-between', // Space between text and icon
                                        alignItems: 'center', // Center items vertically
                                        width: '100%', // Set to 100% to fill the grid cell
                                      }}
                                      title={file.filename}
                                    >
                                      <span>{`${name}...${extension}`}</span>
                                      <Xicon
                                        onClick={() => removeSingleFile(id)}
                                        className='cursor-pointer'
                                      />
                                    </div>
                                  )
                                })}
                            </>
                          )}
                        </Stack>
                      </div>
                    </div>
                  </>
                )}
              </div>
            )}
            {companyVerificationMethod === 1 && !isAgentClientOnboarding && (
              <div className='row'>
                <div className='col-md-6 mb-5'>
                  <div className='mb-2'>
                    <div>
                      <label
                        htmlFor=''
                        style={{ fontSize: '16px', fontWeight: 500 }}
                        className='input-field-label required'
                      >
                        Credit Bureau Singapore Documents
                      </label>
                    </div>
                    <a
                      className='text-primary fw-bold mb-7'
                      style={{
                        fontSize: '14px',
                        borderBottom: '1px solid var(--primary-color)',
                        cursor: 'pointer',
                        display: 'inline-block',
                        lineHeight: '1.1',
                      }}
                      href='https://www.creditbureau.com.sg/buy-my-credit-report.html'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Learn How To Download?
                    </a>
                  </div>
                  <div
                    className='uploadBoxCoApp'
                    style={{
                      border: '1px dashed var(--primary-color)',
                      background: 'var(--primary-light-color)',
                      minHeight: '150px',
                      fontSize: '14px',
                      marginBottom: '15px',
                      borderRadius: '10px',
                      alignItems: 'center',
                    }}
                    onDrop={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                      const files = e.dataTransfer.files
                      if (files.length) {
                        const event = { target: { files, validity: { valid: true } } }
                        handleFileUpload(event, 'credit-bureau-singapore-document', [
                          'application/pdf',
                          'application/msword',
                          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        ])
                      }
                    }}
                    onDragOver={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                    onDragLeave={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                  >
                    <Stack
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      gap={2} // Increased gap for better spacing
                    >
                      <div className='upload mb-4'>
                        <input
                          id='upload-credit-bureau-singapore-document'
                          type='file'
                          multiple
                          accept='.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                          onChange={(e: any) =>
                            handleFileUpload(e, 'credit-bureau-singapore-document', [
                              'application/pdf',
                              'application/msword',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                            ])
                          }
                          onDrop={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                            const files = e.dataTransfer.files
                            if (files.length) {
                              const event = { target: { files, validity: { valid: true } } }
                              handleFileUpload(event, 'credit-bureau-singapore-document', [
                                'application/pdf',
                                'application/msword',
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                              ])
                            }
                          }}
                          onDragOver={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                          onDragLeave={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                        ></input>
                        <label
                          htmlFor='upload-credit-bureau-singapore-document'
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            className='file-uploader'
                            style={{
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                            }}
                          >
                            <UploadIcon color='var(--primary-color)' />

                            <span className='dragDropTitle'>Drag & Drop CBS Documents</span>
                          </div>
                          <div className='file-uploader-sub'>Supported formats: PDF, DOCX</div>
                        </label>
                      </div>
                    </Stack>
                  </div>
                  <div className='uploadedCapsulesWrap'>
                    <Stack
                      className='uploadedCapsules gridCapsules'
                      style={{
                        display: 'grid', // Change to grid layout
                        gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                        gap: '12px', // Adjusted gap for better spacing
                        fontSize: '12px',
                        minWidth: '100%',
                      }}
                    >
                      {fileGroup && fileGroup.length > 0 && (
                        <>
                          {fileGroup
                            .filter(({ type }: any) => type === 'credit-bureau-singapore-document')
                            .map(({ file, type, id }: any, i: number) => {
                              const filename = file.filename.split('.')
                              const name = filename[0].substring(0, 10)
                              const extension = filename[1]

                              return (
                                <>
                                  <div
                                    key={i}
                                    style={{
                                      fontSize: 14,
                                      color: '#616B75',
                                      background: '#F9FAFA',
                                      borderRadius: '20px',
                                      border: '1px solid #E0E0E0',
                                      padding: '8px 16px',
                                      display: 'flex', // Use flex to position items
                                      justifyContent: 'space-between', // Space between text and icon
                                      alignItems: 'center', // Center items vertically
                                      width: '100%', // Set to 100% to fill the grid cell
                                    }}
                                    title={file.filename}
                                  >
                                    <span>{`${name}...${extension}`}</span>
                                    <Xicon
                                      onClick={() => removeSingleFile(id)}
                                      className='cursor-pointer'
                                    />
                                  </div>
                                </>
                              )
                            })}
                        </>
                      )}
                    </Stack>
                  </div>
                </div>

                <div className='col-md-6 mb-5'>
                  <div className='mb-2'>
                    <div>
                      <label
                        htmlFor=''
                        style={{ fontSize: '16px', fontWeight: 500 }}
                        className='input-field-label required'
                      >
                        MLCB Report
                      </label>
                    </div>
                    <a
                      className='text-primary fw-bold mb-7'
                      style={{
                        fontSize: '14px',
                        borderBottom: '1px solid var(--primary-color)',
                        cursor: 'pointer',
                        display: 'inline-block',
                        lineHeight: '1.1',
                      }}
                      href='https://www.mlcb.com.sg/buy-loan.html'
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      Learn How To Download?
                    </a>
                  </div>
                  <div
                    className='uploadBoxCoApp'
                    style={{
                      border: '1px dashed var(--primary-color)',
                      background: 'var(--primary-light-color)',
                      minHeight: '150px',
                      fontSize: '14px',
                      marginBottom: '15px',
                      borderRadius: '10px',
                      alignItems: 'center',
                    }}
                    onDrop={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                      const files = e.dataTransfer.files
                      if (files.length) {
                        const event = { target: { files, validity: { valid: true } } }
                        handleFileUpload(event, 'mlcb-report', [
                          'application/pdf',
                          'application/msword',
                          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                        ])
                      }
                    }}
                    onDragOver={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                    onDragLeave={(e: React.DragEvent) => {
                      e.preventDefault()
                      e.stopPropagation()
                    }}
                  >
                    <Stack
                      style={{
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      gap={2} // Increased gap for better spacing
                    >
                      <div className='upload mb-4'>
                        <input
                          id='upload-mlcb-report'
                          type='file'
                          multiple
                          accept='.pdf,.doc,.docx,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                          onChange={(e: any) =>
                            handleFileUpload(e, 'mlcb-report', [
                              'application/pdf',
                              'application/msword',
                              'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                            ])
                          }
                          onDrop={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                            const files = e.dataTransfer.files
                            if (files.length) {
                              const event = { target: { files, validity: { valid: true } } }
                              handleFileUpload(event, 'mlcb-report', [
                                'application/pdf',
                                'application/msword',
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                              ])
                            }
                          }}
                          onDragOver={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                          onDragLeave={(e: React.DragEvent) => {
                            e.preventDefault()
                            e.stopPropagation()
                          }}
                        ></input>
                        <label
                          htmlFor='upload-mlcb-report'
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <div
                            className='file-uploader'
                            style={{
                              cursor: 'pointer',
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                            }}
                          >
                            <UploadIcon color='var(--primary-color)' />

                            <span className='dragDropTitle'>Drag & Drop MLCB Report</span>
                          </div>
                          <div className='file-uploader-sub'>Supported formats: PDF, DOCX</div>
                        </label>
                      </div>
                    </Stack>
                  </div>
                  <div className='uploadedCapsulesWrap'>
                    <Stack
                      className='uploadedCapsules gridCapsules'
                      style={{
                        display: 'grid', // Change to grid layout
                        gridTemplateColumns: 'repeat(6, 1fr)', // Create 6 equal columns
                        gap: '12px', // Adjusted gap for better spacing
                        fontSize: '12px',
                        minWidth: '100%',
                      }}
                    >
                      {fileGroup && fileGroup.length > 0 && (
                        <>
                          {fileGroup
                            .filter(({ type }: any) => type === 'mlcb-report')
                            .map(({ file, type, id }: any, i: number) => {
                              const filename = file.filename.split('.')
                              const name = filename[0].substring(0, 10)
                              const extension = filename[1]

                              return (
                                <>
                                  <div
                                    key={i}
                                    style={{
                                      fontSize: 14,
                                      color: '#616B75',
                                      background: '#F9FAFA',
                                      borderRadius: '20px',
                                      border: '1px solid #E0E0E0',
                                      padding: '8px 16px',
                                      display: 'flex', // Use flex to position items
                                      justifyContent: 'space-between', // Space between text and icon
                                      alignItems: 'center', // Center items vertically
                                      width: '100%', // Set to 100% to fill the grid cell
                                    }}
                                    title={file.filename}
                                  >
                                    <span>{`${name}...${extension}`}</span>
                                    <Xicon
                                      onClick={() => removeSingleFile(id)}
                                      className='cursor-pointer'
                                    />
                                  </div>
                                </>
                              )
                            })}
                        </>
                      )}
                    </Stack>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div style={{ marginBottom: '30px' }}>
          <div className='cardNew' style={{ marginBottom: '0px' }}>
            <div className='section-heading'>
              <h2>Personal Guarantor / Shareholder Consent</h2>
              <hr className='text-gray-400' />
            </div>
            <div ref={confirmCheckboxRef}>
              <label className='form-check form-check-inline form-check-solid me-5'>
                <input
                  name='confirmCheckbox'
                  type='checkbox'
                  className={`form-check-input ${
                    (formik.submitCount > 0 || formik.errors.confirmCheckbox) &&
                    !formik.values.confirmCheckbox
                      ? 'is-invalid'
                      : ''
                  }`}
                  checked={formik.values.confirmCheckbox}
                  onChange={formik.handleChange}
                />
                <span className='ps-2 fs-4 text-justified'>
                  <b>By submitting this information, I hereby:</b> <br />
                  <ul className='text-justify gap-4 mt-4'>
                    <li className='mb-4'>
                      Confirm that I am submitting a formal loan application, which will be
                      processed by CCR Partners, CrediLinq A.I Pte Ltd. and their respective
                      affiliates and partners consulting credit bureaus, and to the sharing of my
                      personal and business data between them for the purpose of processing the
                      relevant loan application.
                    </li>

                    <li className={'mb-4'}>
                      Declare that all information provided is true, complete, and accurate to the
                      best of my knowledge.
                    </li>
                    <li className={'mb-4'}>
                      Give my explicit consent to CCR Partners and its authorized personnel to
                      contact me using the contact details provided, including but not limited to
                      email, phone call, WhatsApp, and SMS/text message. Such communication will
                      pertain solely to the status and processing of the loan application.
                    </li>
                  </ul>
                </span>
              </label>
              {/* <label className='form-check form-check-inline form-check-solid me-5'>
                <input
                  name='promotionalMarketingCheckbox'
                  type='checkbox'
                  className={`form-check-input`}
                  checked={formik.values.promotionalMarketingCheckbox}
                  onChange={formik.handleChange}
                />
                <span className='ps-2 fs-4 text-justified'>
                  I agree to receive marketing and promotional materials from "CCR Partners" via
                  email, SMS, phone calls, and other communication channels.
                </span>
              </label> */}
              <div className='mt-5'>
                <span
                  className='ps-2 fs-4 text-justified'
                  style={{ marginTop: '10px', fontWeight: 700 }}
                >
                  CCR Partners confirms that this application process complies with applicable data
                  protection laws. Our full privacy policy is available [
                  <a
                    href={toNotice()}
                    className='text-primary-dark'
                    style={{ fontWeight: 500, textDecoration: 'underline' }}
                    target='_blank'
                    rel='noopener noreferrer'
                  >
                    Click Here
                  </a>
                  ].
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className='text-danger border-text'>
          {formik.errors.confirmCheckbox || <div>{formik.errors.confirmCheckbox}</div>}
        </div>
        <div className='cardNew stickeyFooter'>
          <div className='d-flex justify-content-between'>
            <button className='button button-outline-primary' onClick={backLink}>
              <LeftArowIcon color='currentColor' fontSize={12} />
              Back
            </button>
            <button
              type='submit'
              className='button button-primary'
              disabled={
                // Disable if:
                // 1. For company verification method 2: all 3 file types must be uploaded
                // 2. For company verification method 1: only credit bureau document is required
                // 3. Or if form is not valid or submitting
                !fileGroupValidation() || !formik.isValid || formik.isSubmitting
              }
            >
              Submit <RightAeroIcon color='currentColor' />
            </button>
          </div>
        </div>
      </form>

      {showAlert && (
        <Alert variant={alertType} showAlert={showAlert} setShowAlert={setShowAlert}>
          {alertMsg}
        </Alert>
      )}

      {openVerification && (
        <UserVerification
          show={openVerification}
          handleClose={() => {
            dispatch(setOpenVerification(false))
            if (companyVerificationMethod === 1) {
              dispatch(setSubStep(2))
            } else {
              dispatch(setSubStep(3))
            }
          }}
          goToStep={() => {
            dispatch(setSubStep(3))
          }}
        />
      )}
    </div>
  )
}

export { Step1Sub3 }
